import * as React from 'react'

import type {
  IDomainEvent} from '@app/domain/domain-events/domain-events.interface';
import {
  DomainEventType,
} from '@app/domain/domain-events/domain-events.interface'

import { BroadcastRow } from './broadcast'
import { DefaultDomainEventRow } from './default-domain-event'

interface Props {
  domainEvent: IDomainEvent
  expandedRows: Record<string, boolean>
  index: number
}

export const DomainEventRow = function ({
  domainEvent,
  expandedRows,
  index,
}: Props) {
  switch (domainEvent.type) {
    case DomainEventType.BroadcastFailure:
    case DomainEventType.BroadcastSuccess:
      return (
        <BroadcastRow
          domainEvent={domainEvent}
          expandedRows={expandedRows}
          index={index}
        />
      )

    default:
      return (
        <DefaultDomainEventRow
          domainEvent={domainEvent}
          expandedRows={expandedRows}
          index={index}
        />
      )
  }
}
